import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "detail-container" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "description" }
const _hoisted_4 = { class: "size-description" }
const _hoisted_5 = { class: "max-size-description" }
const _hoisted_6 = { class: "upload-action" }
const _hoisted_7 = ["accept"]

import { VButton, VIconSvg, VModalMediaAssets } from "@/components";
import VErrorTooltip from "../VErrorTooltip/VErrorTooltip.vue";
import { pick } from "lodash";
import NotifyService from "@/services/notify.service";
import { computed, ref } from "vue";
import i18n from "@/plugins/vue-i18n";
import store from "@/store";

import { VideoPlayer } from "@videojs-player/vue";
interface Props {
  value?: {
    id: number | null;
    originName: string;
    url: string;
    width: number;
    height: number;
    mimeType: string;
  };
  allowedFileTypes?: Array<string>;
  maxWeight?: number;
  maxDuration?: number;
  error?: string;
  required?: boolean;

  side?: "advert" | "admin";
  userId?: number;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'VUploadVideo',
  props: {
    value: { default: () => {
    return {
      id: null,
      originName: "",
      url: "",
      width: 0,
      height: 0,
      mimeType: "",
    };
  } },
    allowedFileTypes: { default: () => ["mp4", "webm"] },
    maxWeight: { default: 64 },
    maxDuration: { default: 30 },
    error: { default: "" },
    required: { type: Boolean, default: false },
    side: { default: "advert" },
    userId: { default: undefined }
  },
  emits: ["input"],
  setup(__props: any, { emit: __emit }) {

VideoPlayer.compatConfig = { MODE: 3 };

const emit = __emit;

const videoPlayerRef = ref();
const fileRef = ref();

const props = __props;

const video = computed({
  get() {
    return props.value;
  },

  set(value) {
    emit("input", value);
  },
});

const playerOptions = computed(() => {
  return {
    language: "en",
    sources: [
      {
        // type: this.video.mimeType, // RND-1308 (player error on 'video/quicktime' mime type)
        src: video.value.url,
      },
    ],
  };
});

const isExistVideo = computed(() => {
  return !!Object.keys(video.value).length;
});

const fileTypesString = computed(() => {
  return props.allowedFileTypes.map((item) => `.${item}`).join(", ");
});
const primaryDescription = computed(() => {
  const fileTypes = props.allowedFileTypes.join(", ");

  return `${i18n.t("page.campaign.maximumDuration")} ${props.maxDuration} ${i18n.t(
    "page.campaign.sec"
  )}; ${fileTypes}`;
});

const containerClasses = computed(() => {
  return {
    "upload-video-wrapper-required": props.required,
  };
});

const isValidVideo = async (file: File) => {
  const fileCheck = new Promise((resolve) => {
    const reader = new FileReader();

    reader.readAsDataURL(file);

    reader.onload = (event) => {
      const fileWeight = (event.total / (1024 * 1024)).toFixed(2);
      let isValid = +props.maxWeight >= +fileWeight;

      if (!isValid) {
        NotifyService.notify({
          type: "error",
          text: i18n.t("component.notify.error.wrongFileWeight", { weight: props.maxWeight }),
          duration: NotifyService.DURATION_LONG,
        });
      }

      const videoElement = document.createElement("video");

      videoElement.preload = "metadata";

      videoElement.onloadedmetadata = () => {
        window.URL.revokeObjectURL(videoElement.src);
        const duration = videoElement.duration;

        isValid = duration <= props.maxDuration;

        if (!isValid) NotifyService.error("wrongVideoDuration");

        resolve(isValid);
      };

      videoElement.src = URL.createObjectURL(file);
    };
  });

  return await Promise.resolve(fileCheck);
};

const upload = async (file: File) => {
  if (await isValidVideo(file)) {
    const data = await store.dispatch("media-asset/uploadVideo", file);

    video.value = pick(data, ["id", "originName", "url", "width", "height", "mimeType"]);
  }
};

const createFile = () => {
  const [file] = event.target.files;

  upload(file);

  fileRef.value.value = null;
};

const onDrop = (event: DragEvent) => {
  if (!isExistVideo.value) {
    event.stopPropagation();
    event.preventDefault();
    const [file] = event.dataTransfer.files;

    upload(file);
  }
};

// const onClickUpload = () => {
//   fileRef.value.click();
// };

const removeFile = () => {
  video.value = {};
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["upload-video-container", containerClasses.value])
  }, [
    (isExistVideo.value)
      ? (_openBlock(), _createBlock(_unref(VideoPlayer), {
          key: 0,
          ref_key: "videoPlayerRef",
          ref: videoPlayerRef,
          class: "video-player-box",
          options: playerOptions.value,
          playsinline: "",
          controls: ""
        }, null, 8, ["options"]))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "upload-video",
          "data-cy": "upload-video-drag-and-drop",
          onDragover: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"])),
          onDrop: onDrop
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("title.video")), 1),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("span", _hoisted_4, _toDisplayString(primaryDescription.value), 1),
              _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t("component.videoUpload.maxSizeMessage")), 1)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_unref(VButton), {
                text: _ctx.$t('button.upload'),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$refs.modalMediaAssets.show()))
              }, null, 8, ["text"]),
              _createElementVNode("input", {
                id: "file-input",
                ref_key: "fileRef",
                ref: fileRef,
                type: "file",
                accept: fileTypesString.value,
                hidden: "",
                "data-cy": "upload-video-input",
                onChange: createFile
              }, null, 40, _hoisted_7)
            ])
          ])
        ], 32)),
    (isExistVideo.value)
      ? (_openBlock(), _createBlock(_unref(VButton), {
          key: 2,
          variant: "secondary",
          "data-cy": "button-remove-video",
          class: "delete",
          onClick: removeFile
        }, {
          "icon-left": _withCtx(() => [
            _createVNode(_unref(VIconSvg), {
              name: "Delete",
              color: "fc-ink"
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_unref(VModalMediaAssets), {
      ref: "modalMediaAssets",
      "media-asset": video.value,
      "onUpdate:mediaAsset": _cache[2] || (_cache[2] = ($event: any) => ((video).value = $event)),
      "media-type": "video",
      "max-weight": props.maxWeight,
      "max-duration": props.maxDuration,
      "allowed-file-types": props.allowedFileTypes,
      side: _ctx.side,
      "user-id": _ctx.userId
    }, null, 8, ["media-asset", "max-weight", "max-duration", "allowed-file-types", "side", "user-id"]),
    (_ctx.error)
      ? (_openBlock(), _createBlock(VErrorTooltip, {
          key: 3,
          error: _ctx.error
        }, null, 8, ["error"]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})